// extracted by mini-css-extract-plugin
export var active = "_gf-7";
export var blink = "_gf-8";
export var dropDownSelector = "_gf-4";
export var dropDownWrapper = "_gf-3";
export var fakeCursor = "_gf-6";
export var fontSizeButton = "_gf-9";
export var formQuillEditor = "_gf-0";
export var pressed = "_gf-a";
export var qlBlank = "_gf-1";
export var textFormattingToolbar = "_gf-2";
export var textToolbarOption = "_gf-5";